import {
  Box,
  Button,
  Drawer,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";

import React, { useEffect } from "react";
import CustomerPanel from "./CustomerPanel";
import DatePanel from "./DatePanel";
import OrderPanel from "./OrderPanel";
import PaymentPanel from "./PaymentPanel";
import ProductPanel from "./ProductPanel";
import SortPanel from "./SortPanel";
import VendingPanel from "./VendingPanel";
import GstPanel from "./GstPanel";
import LocationPanel from "./LocationPanel";

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && <Box sx={{ p: 2, flexGrow: 1 }}>{children}</Box>}
    </Box>
  );
}

const SalesFilterDrawer = ({
  open,
  toggleDrawer,
  filter,
  setFilter,
  onApplyFilter,
  clearFilters,
}) => {
  const [value, setValue] = React.useState(0);

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Drawer anchor="right" open={open} onClose={() => toggleDrawer(false)}>
      <Box
        sx={{
          flexGrow: 1,
          bgcolor: "background.paper",
          display: "flex",
          width: isSmallScreen ? 350 : 450,
        }}
      >
        <Tabs
          orientation="vertical"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          variant="fullWidth"
        >
          <Tab
            label="Order"
            {...a11yProps(0)}
            sx={{ writingMode: "vertical-rl", marginY: 1, paddingY: 1 }}
          />
          <Tab
            label="Product"
            {...a11yProps(1)}
            sx={{ writingMode: "vertical-rl", marginY: 1, paddingY: 4 }}
          />
          <Tab
            label="GST"
            {...a11yProps(1)}
            sx={{ writingMode: "vertical-rl", marginY: 1, paddingY: 4 }}
          />
          <Tab
            label="Payment"
            {...a11yProps(2)}
            sx={{ writingMode: "vertical-rl", marginY: 1, paddingY: 4 }}
          />
          <Tab
            label="Location"
            {...a11yProps(3)}
            sx={{ writingMode: "vertical-rl", marginY: 1, paddingY: 4 }}
          />
          <Tab
            label="Customer"
            {...a11yProps(3)}
            sx={{ writingMode: "vertical-rl", marginY: 1, paddingY: 4 }}
          />
          <Tab
            label="Date"
            {...a11yProps(4)}
            sx={{ writingMode: "vertical-rl", marginY: 1, paddingY: 2 }}
          />
          <Tab
            label="Vending"
            {...a11yProps(5)}
            sx={{ writingMode: "vertical-rl", marginY: 1, paddingY: 4 }}
          />
          <Tab
            label="Sort"
            {...a11yProps(6)}
            sx={{ writingMode: "vertical-rl", marginY: 1, paddingY: 2 }}
          />
        </Tabs>
        <TabPanel value={value} index={0}>
          <OrderPanel filter={filter} setFilter={setFilter} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ProductPanel filter={filter} setFilter={setFilter} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <GstPanel filter={filter} setFilter={setFilter} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <PaymentPanel filter={filter} setFilter={setFilter} />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <LocationPanel filter={filter} setFilter={setFilter} />
        </TabPanel>
        <TabPanel value={value} index={5}>
          <CustomerPanel filter={filter} setFilter={setFilter} />
        </TabPanel>
        <TabPanel value={value} index={6}>
          <DatePanel filter={filter} setFilter={setFilter} />
        </TabPanel>
        <TabPanel value={value} index={7}>
          <VendingPanel filter={filter} setFilter={setFilter} />
        </TabPanel>
        <TabPanel value={value} index={8}>
          <SortPanel filter={filter} setFilter={setFilter} />
        </TabPanel>
      </Box>
      <Button
        variant="outlined"
        color="info"
        sx={{ marginX: 2 }}
        onClick={clearFilters}
      >
        Clear all filters
      </Button>
      <Button
        variant="outlined"
        sx={{ marginX: 2, mb: 2, mt: 1 }}
        onClick={onApplyFilter}
      >
        Apply filter
      </Button>
    </Drawer>
  );
};

export default SalesFilterDrawer;
